export const LOGIN_LOADING = 'LOGIN_LOADING'
export const LOGIN_ADMIN = 'LOGIN_ADMIN'
export const LOGIN_REGISTER = 'LOGIN_REGISTER'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGOUT = 'LOGOUT'
export const FORM_LOADING = 'FORM_LOADING'
export const FORM_FINISH_LOADING = 'FORM_FINISH_LOADING'
export const FULLY_LOADED_FORM_DATA = 'FULLY_LOADED_FORM_DATA'
export const RECIEVE_FORM_DATA = 'RECIEVE_FORM_DATA'
export const RECIEVE_FORM_KHUSUS = 'RECIEVE_FORM_KHUSUS'
export const RESET_FORM_DATA = 'RESET_FORM_DATA'
export const FILTER_FORM = 'FILTER_FORM'
export const FILTER_GRUP = 'FILTER_GRUP'
export const VERIFICATION_LOADING = 'VERIFICATION_LOADING'
export const VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS'
export const VERIFICATION_ERROR = 'VERIFICATION_ERROR'
export const VERIFICATION_CLOSE_MODAL = 'VERIFICATION_CLOSE_MODAL'
export const VERIFICATION_RESET = 'VERIFICATION_RESET'
export const PENAWARAN_JALUR_RECEIVE = 'PENAWARAN_JALUR_RECEIVE'
export const PENAWARAN_JALUR_AKTIF_RECEIVE = 'PENAWARAN_JALUR_AKTIF_RECEIVE'
export const JENJANG_RECEIVE = 'JENJANG_RECEIVE'
export const JALUR_RECIEVE = 'JALUR_RECIEVE'
export const TAHUN_RECIEVE = 'TAHUN_RECIEVE'
export const FAKULTAS_RECIEVE = 'FAKULTAS_RECIEVE'
export const PROGRAM_STUDI_RECIEVE = 'PROGRAM_STUDI_RECIEVE'
export const CATATAN_FORMULIR_RECIEVE = 'CATATAN_FORMULIR_RECIEVE'
export const CATATAN_FORMULIR_RESET = 'CATATAN_FORMULIR_RESET'
export const YUDISIUM_LOADING = 'YUDISIUM_LOADING'
export const YUDISIUM_CHECK = 'YUDISIUM_CHECK'
export const YUDISIUM_FINISH_LOADING = 'YUDISIUM_FINISH_LOADING'
export const YUDISIUM_ERROR = 'YUDISIUM_ERROR'
export const LOA_LOADING = 'LOA_LOADING'
export const LOA_REQUEST = 'LOA_REQUEST'
export const LOA_STATUS_CONDITIONAL = 'LOA_STATUS_CONDITIONAL'
export const LOA_STATUS = 'LOA_STATUS'
export const STATUS_PENDAFTAR = 'STATUS_PENDAFTAR'
export const STATUS_YUDISIUM = 'STATUS_YUDISIUM'
export const RESET_STATUS = 'RESET_STATUS'
export const PENGUMUMAN_RECIEVE = 'PENGUMUMAN_RECIEVE'
export const ONE_PENGUMUMAN_RECEIVE = 'ONE_PENGUMUMAN_RECEIVE'
export const BERITA_RECIEVE = 'BERITA_RECIEVE'
export const ONE_BERITA_RECEIVE = 'ONE_BERITA_RECEIVE'
export const CONVERSATION_RECEIVE = 'CONVERSATION_RECEIVE'
export const PUSH_CONVERSATION = 'PUSH_CONVERSATION'
export const TOGGLE_OPENCHAT = 'TOGGLE_OPENCHAT'
export const TOGGLE_DISABILITY = 'TOGGLE_DISABILITY'

export const USER_DATA_DIRI_SAVED = 'USER_DATA_DIRI_SAVED'
export const USER_DATA_AYAH_SAVED = 'USER_DATA_AYAH_SAVED'
export const USER_DATA_IBU_SAVED = 'USER_DATA_IBU_SAVED'
export const USER_DATA_KESEHATAN_SAVED = 'USER_DATA_KESEHATAN_SAVED'
export const USER_DATA_PRESTASI_SAVED = 'USER_DATA_PRESTASI_SAVED'
export const USER_PENDIDIKAN_SEBELUMNYA_S1_SAVED = 'USER_PENDIDIKAN_SEBELUMNYA_S1_SAVED'
export const USER_PENDIDIKAN_SEBELUMNYA_S2_SAVED = 'USER_PENDIDIKAN_SEBELUMNYA_S2_SAVED'
export const USER_DATA_PENELITIAN_SAVED = 'USER_DATA_PENELITIAN_SAVED'
export const USER_DATA_KARYA_TULIS_SAVED = 'USER_DATA_KARYA_TULIS_SAVED'
export const USER_DATA_SERTIFIKASI_SAVED = 'USER_DATA_SERTIFIKASI_SAVED'
export const USER_DATA_DISERTASI_SAVED = 'USER_DATA_DISERTASI_SAVED'
export const USER_DATA_PROPOSAL_TESIS_SAVED = 'USER_DATA_PROPOSAL_TESIS_SAVED'
export const USER_DATA_PILIHAN_JURUSAN_SAVED = 'USER_DATA_PILIHAN_JURUSAN_SAVED'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js